import React from 'react';
import styled from 'styled-components';
import { Grid, Type } from '../../app/StyleGuide';
import WhiteLabel from '../../filters/WhiteLabel';
import { Step } from './models/course';
import { StepsMenuProgressBar } from './components/StepsMenuProgressBar';

type Course = {
  progress: number | { _type: string; percent: number };
  tasks: Step[];
  status?: string;
  completedOn?: string | number;
  timeCompleted?: number;
  dueDate?: string | number;
};

type CourseInformationProps = {
  course: Course;
  numCompletedSteps: number;
  progress: number;
};

const formatDate = (date: string | number) => new Date(date).toLocaleDateString();

const Container = styled.div`
  ul {
    list-style: none;
    margin: ${Grid._4} 0;
    padding: 0;
  }
  li {
    color: ${Type.Color.medium};
    display: inline-block;
    &:not(:last-of-type)::after {
      content: '•';
      margin: 0 ${Grid._3};
    }
  }
`;

const CourseInformation = ({ course, numCompletedSteps, progress }: CourseInformationProps) => {
  const isComplete =
    typeof course.progress === 'object' && course.progress._type
      ? course.progress._type === 'Finished'
      : course.status === 'complete';
  const completedOn =
    isComplete && course.completedOn
      ? formatDate(course.completedOn)
      : course.timeCompleted
      ? formatDate(course.timeCompleted)
      : undefined;
  const dueDate = course.dueDate && formatDate(course.dueDate);

  return (
    <Container>
      <ul>
        {isComplete ? (
          <li>
            {numCompletedSteps} {WhiteLabel.labels.step + (numCompletedSteps > 1 ? 's' : '')} completed on {completedOn}
          </li>
        ) : (
          <li>
            {numCompletedSteps} of {course.tasks.length} {WhiteLabel.labels.step + (course.tasks.length > 1 ? 's' : '')}{' '}
            complete
          </li>
        )}
        {!isComplete && dueDate && <li data-qa-hook="assignedTaskListPanelDueDate">Finish by {dueDate}</li>}
      </ul>
      <StepsMenuProgressBar progress={progress} />
    </Container>
  );
};

export default CourseInformation;
